import { toast } from "react-toastify";

const useToastify = () => {
    const baseOptions = {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    };

    // a copy - the options of one toast (e.g. toastId) must not stay for the next ones
    const getOptions = (options) => options && typeof (options) === "object" ? Object.assign({}, baseOptions, options) : baseOptions;

    const toastify = (level, topLevelOptions) => (msg, options) => toast[level](msg, getOptions(options, topLevelOptions));

    return {
        toastifyInfo: toastify("info"),
        toastifySuccess: toastify("success"),
        toastifyWarn: toastify("warn"),
        toastifyError: toastify("error"),
        toastifyDark: toastify("dark", { className: "success_btn margin-l-20", bodyClassName: "toast_body" })
    };
}

export default useToastify;